"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8.41 10l5.29-5.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-6 6c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l6 6a1.003 1.003 0 001.42-1.42L8.41 10z"];
//# sourceMappingURL=chevron-left.js.map